import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class WaitingListModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][WaitingListModel] organizationId is mandatory`);
        }
        if (eventId) {
            return `/ticket/organizations/${organizationId}/events/${eventId}/waiting_lists`;
        }
        return `/ticket/organizations/${organizationId}/waiting_lists`;
    }
}
